import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
  } from "react-router-dom";

import Header from './components/Header';

import Home from './components/Home';
import Gaming from './components/Gaming';
import Casino from './components/Casino';
import Nftmarket from './components/Nftmarket';
import Nftstaking from './components/Nftstaking';
import House_farms from './components/House_farms';
import House_staking from './components/House_staking';


function App() {
  const [date, setDate] = useState(null);
  useEffect(() => {
    async function getDate() {
      const res = await fetch('/api/date');
      const newDate = await res.text();
      setDate(newDate);
    }
    getDate();
  }, []);
  return (
    <main>
	<div id="preloder">
		<div class="loader"></div>
	</div>
	<Header></Header>
	<div class="row">
		
		<Router>
		<div class="col-md-2">
			<nav id="navbar">
				<ul>
					<li class="mobilelogo">
						<a href="#" class="mobileicon"><img src={`${process.env.PUBLIC_URL}/images/mobilenav.png`} /></a>
						<img src={`${process.env.PUBLIC_URL}/images/logo.png`} />
					</li>
					<li><NavLink to="/" activeClassName="active"><img src={`${process.env.PUBLIC_URL}/images/home_icon.svg`} />Home</NavLink></li>
					<li><NavLink to="/gaming" activeClassName="active"><img src={`${process.env.PUBLIC_URL}/images/gaming_mouse.png`} />Gaming</NavLink></li>
					<li><NavLink to="/casino" activeClassName="active"><img src={`${process.env.PUBLIC_URL}/images/casino_icon.png`} />Casino</NavLink></li>
					<li><NavLink to="/nftmarket" activeClassName="active"><img src={`${process.env.PUBLIC_URL}/images/nft_icon.png`} />NFT Marketplace</NavLink></li>
					<li><NavLink to="/nftstaking" activeClassName="active"><img src={`${process.env.PUBLIC_URL}/images/NFT_staking.png`} />NFT staking</NavLink></li>
					<li><NavLink to="/house_farms" activeClassName="active"><img src={`${process.env.PUBLIC_URL}/images/house_farms.png`} />House Farms</NavLink></li>
					<li><NavLink to="/house_staking" activeClassName="active"><img src={`${process.env.PUBLIC_URL}/images/house_staking.png`} />House Staking</NavLink></li>
				</ul>
			</nav>
		</div>
			<Switch>
            <Route path="/gaming"> <Gaming /></Route>
            <Route path="/casino"><Casino /></Route>
            <Route path="/nftmarket"> <Nftmarket /> </Route>
			<Route path="/nftstaking"> <Nftstaking /> </Route>
			<Route path="/house_farms"> <House_farms /> </Route>
			<Route path="/house_staking"> <House_staking /> </Route>
            <Route path="/"><Home /> </Route>
        </Switch>
		</Router>
		
		
	</div>
    </main>
  );
}

export default App;
